import { metrics } from '@seek/metrics-js';

type ServerFetchAuthFailureEvent = {
  name: 'serverFetchAuthFailure';
  action: string;
};
type AuthMismatchEvent = {
  name: 'authMismatch';
  csa: boolean;
  ssa: boolean;
};
type LastKnownSolIdNotSetEvent = {
  name: 'lastKnownSolIdNotSet';
  csa: boolean;
  ssa: boolean;
};
type Auth0SSOSessionEvent = {
  name: 'auth0SSOSession';
  isAuthenticated: boolean;
  error?: string;
};

type AuthEventType =
  | Auth0SSOSessionEvent
  | AuthMismatchEvent
  | LastKnownSolIdNotSetEvent
  | ServerFetchAuthFailureEvent;

export const fireAuthMetric = <T extends AuthEventType>({ name, ...tags }: T) =>
  metrics.count('auth.event', [
    `event:${name}`,
    ...Object.entries(tags)
      .filter(([_, value]) => value !== undefined)
      .map(([key, value]) => `${key}:${value}`),
  ]);
